export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("page:finish", () => {
    if (process.client) {
      document.body.scrollTo(0, 0);
    }
  });
});
